<template>
  <div id="app" :style="minWidth">  <!--min-width 1024 + navbar 256px-->
    <header-menu v-if="logined"></header-menu>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
export default {
  name: 'app',
  components: {
    // Console chrome — only rendered for signed-in console sessions, so it
    // loads as its own chunk instead of riding in the entry.
    'header-menu': () => import(/* webpackChunkName: "console-header" */ './components/main/header.vue'),
  },
  data () {
    return {
      pagesIgnoreSidebar: {
        "/relationship-mapping": true,
        "/reward-message": true,
        "/user-registration": true,
        "/login": true,
        "/monthly-insights": true,
        "/weekly-insights": true,
        "/daily-insights": true,
        "/document-developer": true,
        "/company-health-status": true,
      },
      pagesMinWidht: {
        "/relationship-mapping": "450px",
        "/reward-message": "auto",
        "/user-registration": "auto",
        "/monthly-insights": "auto",
        "/weekly-insights": "616px",
        "/daily-insights": "506px",
        "/document-developer": "auto",
      },
      // newVersion: false
    }
  },
  created () {
    this.$store.dispatch('authen/setUserLogin')
  },
  computed: {
    logined () {
      // if (firebase.auth().currentUser) return true; else return false;
      let userLoged = this.$store.getters['authen/checkLogin'];

      // Pages needed to hide Side bar!
      // let pagesHidingSideBar = true;
      // let currentPate = this.$router.currentRoute.path;
      // if (this.pagesIgnoreSidebar[currentPate]) {
      //   pagesHidingSideBar = false;
      // }

      return userLoged && false;
    },
    minWidth () {
      let minWidth = "auto"; // 1024px, 1280px
      let currentPate = this.$router.currentRoute.path;
      
      if (this.pagesMinWidht[currentPate]) {
        return `min-width: ${this.pagesMinWidht[currentPate]};`;
      }

      let curentWithOutHash = "/" + currentPate.split("/")[1]
      if (curentWithOutHash) {
        return `min-width: ${this.pagesMinWidht[curentWithOutHash]};`;
      }

      return `min-width: ${minWidth};`;
    }
  },
  mounted() {
    // this.checkingVersion()
  },
  methods: {
    // checkingVersion() {
    //   let currentPate = this.$router.currentRoute.path;

    //   let pagesHidingSideBar = true;
    //   if (this.pagesIgnoreSidebar[currentPate]) {
    //     pagesHidingSideBar = false;
    //   }
    //   firebase.database().ref(`version/my_version`).once("value", snapshot => {
    //     if (snapshot.val()) {
    //       localStorage.appVersion = snapshot.val()
    //     }
    //     if (localStorage.userVersion != localStorage.appVersion && pagesHidingSideBar) {
    //       this.newVersion = true;
    //     }
    //   });
    // },
    whatNew() {
      window.open('https://www.notion.so/happilyai/What-s-New-8e5a2d8637fe4cedaf80e317ea861000', '_blank');
    },
    refresh() {
      localStorage.userVersion = localStorage.appVersion
      location.reload(true);
    }
  }
}
</script>